<section class="common-header-wrapper" style="position: relative; height: 100%" [class.drawer-open-wrapper]="dropdownOpen">
  <header id="headerId" class="main-header" *ngIf="!hideNavbar">
    <div class="container-fluid header-bg" style="height: 4rem">
      <div *ngIf="!hideNavbar" class="row align-items-center justify-content-between" style="height: 100%; flex-wrap: nowrap;">
        <!-- Logo -->
        <div class="col-auto">
          <div class="logo">
            <a *ngIf="loginButtonShow == '/Login'" [routerLink]="['/Home']">
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <!-- <img
                src="{{ EmployeeProfileBaseUrl }}logo.png"
                alt="logo"
                class="logo-width"
              /> -->
            </a>
            <a *ngIf="
                loginButtonShow == '/Home' ||
                loginButtonShow == '/' ||
                loginButtonShow == '/index/page'
              ">
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <img src="{{ EmployeeProfileBaseUrl }}logo.png" alt="logo" class="logo-width" />
            </a>
            <a *ngIf="
                loginButtonShow != '/Home' &&
                loginButtonShow != '/' &&
                loginButtonShow != '/Login' &&
                loginButtonShow != '/index/page'
              " [routerLink]="['/index/page']">
              <!-- <img src="../../assets/images/logo.png" alt="logo" class="logo-width" /> -->
              <img src="{{ EmployeeProfileBaseUrl }}logo.png" alt="logo" class="logo-width" />
            </a>
          </div>
        </div>

        <!-- Greeting / Heading -->
        <div class="col-md-6 d-none d-md-block text-center header-company-container">
          <h2 *ngIf="username" class="greeting-text mb-0">
            <span class="company-title">{{ CompanyName }}</span>
          </h2>
        </div>
        <!-- Profile / Actions -->
        <div class="col-auto navRight">
          <ng-container *ngIf="username; else loginButton">
            <app-chat-modal-sheet class="me-2"></app-chat-modal-sheet>
            <app-emi-calculator class="me-2"></app-emi-calculator>

            <div class="profile-drawer-container">
              <a class="user-profile-wrapper d-flex align-items-center cursor-pointer" (click)="toggleDropdown()">
                <img [src]="EmployeeProfileBaseUrl + ProfilePic" (error)="onImageError($event)"
                  class="user-avatar" alt="User" />
                <span class="user-name ms-1">{{ FullName }}</span>
              </a>
            </div>
          </ng-container>

          <ng-template #loginButton>
            <div class="loginContainer">
              <a *ngIf="
                  username == '' &&
                  (loginButtonShow == '/Home' || loginButtonShow == '/')
                " [routerLink]="['/Login']">
                <button class="btn loginBtn btn-lg">Login</button>
              </a>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <!-- Sub heading for desktop -->
    <div class="col-md-12 d-none d-md-block text-center sub-head font-size-12" *ngIf="SUB_Heading">
      <div class="blink_me">{{ SUB_Heading }}</div>
    </div>
  </header>

  <div class="sidebar-mobile-backdrop"></div>

  <div class="common-div" [class.full-height]="hideNavbar">
    <router-outlet></router-outlet>
  </div>

  <!-- Profile Side Drawer & Overlay (Placed at Root Level after common-div to prevent DOM stacking overlap) -->
  <ng-container *ngIf="username">
    <div class="profile-drawer-overlay" *ngIf="dropdownOpen" (click)="dropdownOpen = false"></div>

    <div class="profile-drawer" [class.open]="dropdownOpen">
      <div class="drawer-header">
        <h5 class="m-0">User Profile</h5>
        <button class="close-btn" (click)="dropdownOpen = false">&times;</button>
      </div>
      
      <div class="drawer-body">
        <div class="employee-details text-center">
          <div class="avatar-container mb-3">
            <img [src]="EmployeeProfileBaseUrl + ProfilePic" (error)="onImageError($event)" class="drawer-avatar-large shadow-sm" alt="User" />
          </div>
          <h6 class="user-name-title mb-1">{{ FullName || username }}</h6>
          
          <!-- Designation Badge -->
          <div class="user-designation-badge mb-3">
            <span class="badge-inner">
              <i class="fa fa-id-badge me-1"></i>
              {{ Designation || data?.Designation || data?.Role_Name || 'Administrator' }}
            </span>
          </div>

          <!-- Contact Details Box -->
          <div class="user-info-card text-start mb-2">
            <div class="info-row d-flex align-items-center mb-2" *ngIf="EmpEmail || data?.EmpEmail">
              <div class="icon-wrapper me-2"><i class="fa fa-envelope"></i></div>
              <span class="info-text text-truncate" title="{{ EmpEmail || data?.EmpEmail }}">{{ EmpEmail || data?.EmpEmail }}</span>
            </div>
            <div class="info-row d-flex align-items-center mb-2" *ngIf="Emp_PhoneNo || data?.Emp_PhoneNo">
              <div class="icon-wrapper me-2"><i class="fa fa-phone"></i></div>
              <span class="info-text">{{ Emp_PhoneNo || data?.Emp_PhoneNo }}</span>
            </div>
            <div class="info-row d-flex align-items-center m-0" *ngIf="Department || data?.DepartmentName || data?.Department">
              <div class="icon-wrapper me-2"><i class="fa fa-building"></i></div>
              <span class="info-text">{{ Department || data?.DepartmentName || data?.Department }}</span>
            </div>
          </div>
        </div>

        <hr class="my-2">

        <div class="theme-section mb-3">
          <div class="text-muted font-size-11 mb-2" style="letter-spacing: 0.5px; font-weight: 700;">CHOOSE THEME</div>
          <div class="d-flex theme-selector-row" style="flex-wrap: wrap; gap: 0.5rem; justify-content: flex-start;">
            <span class="theme-dot default-theme" [class.active]="currentTheme === 'default'" (click)="setTheme('default')" title="Classic Navy"></span>
            <span class="theme-dot purple-theme" [class.active]="currentTheme === 'purple'" (click)="setTheme('purple')" title="Purple"></span>
            <span class="theme-dot rose-theme" [class.active]="currentTheme === 'rose'" (click)="setTheme('rose')" title="Rose"></span>
            <span class="theme-dot orange-theme" [class.active]="currentTheme === 'orange'" (click)="setTheme('orange')" title="Orange"></span>
            <span class="theme-dot teal-theme" [class.active]="currentTheme === 'teal'" (click)="setTheme('teal')" title="Teal"></span>
            <span class="theme-dot blue-theme" [class.active]="currentTheme === 'blue'" (click)="setTheme('blue')" title="Blue"></span>
            <span class="theme-dot coral-theme" [class.active]="currentTheme === 'coral'" (click)="setTheme('coral')" title="Coral"></span>
            <span class="theme-dot amber-theme" [class.active]="currentTheme === 'amber'" (click)="setTheme('amber')" title="Amber"></span>
          </div>
        </div>

        <hr class="my-2">

        <div class="drawer-links">
          <a class="drawer-item" (click)="ChangePassword(); dropdownOpen = false">
            <i class="fa fa-key"></i> Change Password
          </a>
          <a class="drawer-item" [routerLink]="['/UserLogout']" (click)="dropdownOpen = false">
            <i class="fa fa-power-off"></i> Logout
          </a>
        </div>
      </div>

      <!-- Footer Utilities at Bottom of Drawer -->
      <div class="drawer-footer">
        <div class="drawer-utilities-title text-muted font-size-11 mb-2" style="letter-spacing: 0.5px; font-weight: 700;">SUPPORT & UTILITIES</div>
        <div class="drawer-links">
          <a href="javascript:void(0)" class="drawer-item" (click)="toggleUtilityDropdown($event)">
            <i class="fa fa-download"></i> Download Utilities <i class="fa" [ngClass]="dropdownVisible ? 'fa-chevron-down' : 'fa-chevron-right'" style="float: right; margin-top: 4px;"></i>
          </a>
          <div class="utility-submenu" *ngIf="dropdownVisible">
            <a href="https://demo.finnaux.com/assets/app-release.apk" target="_blank" download="app-release.apk" class="drawer-item sub-item">
              <i class="fa fa-mobile"></i> Download Mobile App
            </a>
            <a href="https://demo.finnaux.com/assets/FinnauxWeb.msi" target="_blank" download="FinnauxWeb.msi" class="drawer-item sub-item">
              <i class="fa fa-desktop"></i> Download MAC Utility
            </a>
          </div>
          <a href="https://www.rbi.org.in/scripts/BS_ViewNBFCNotification.aspx" target="_blank" class="drawer-item">
            <i class="fa fa-external-link"></i> RBI Circular
          </a>
          <a href="javascript:void(0)" class="drawer-item">
            <i class="fa fa-phone"></i> Contact Us
          </a>
          <a href="javascript:void(0)" class="drawer-item" (click)="openSupport()">
            <i class="fa fa-life-ring"></i> Support
          </a>
        </div>
      </div>
    </div>
  </ng-container>


<div class="modal fade in" id="ChangePasswordModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
  data-backdrop="false" style="background-color: rgba(0, 0, 0, 0.5); overflow: auto">
  <form #ddf="ngForm" (ngSubmit)="onUpdateChangePassword()" novalidate>
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
        <div cdkDragHandle class="modal-header" style="padding: 0.625rem">
          <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
            Change Password
          </h6>
          <button type="button" (click)="OnCloseChangePasswordModal()" class="close" data-dismiss="modal"
            aria-label="Close">
            <span aria-hidden="true">
              <i class="far text-black fa-times-circle"></i>
            </span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row m-0">
            <div class="col-md-12 p-1">
              <span class="required-lable">Old Password</span>
              <input type="password" name="Old_Password " id="Old_Password " #refOld_Password="ngModel" required
                placeholder="Old Password" [ngClass]="{
                  'is-invalid': ddf.submitted && refOld_Password.invalid,
                  'alert-warning':
                    refOld_Password.invalid &&
                    (refOld_Password.dirty ||
                      refOld_Password.touched ||
                      refOld_Password.untouched)
                }" [(ngModel)]="PasswordModel.Old_Password" class="form-control input-text-css" />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable">New Password</span>
              <input type="password" name="New_Password " id="New_Password " #refNew_Password="ngModel" required
                placeholder="New Password" [ngClass]="{
                  'is-invalid': ddf.submitted && refNew_Password.invalid,
                  'alert-warning':
                    refNew_Password.invalid &&
                    (refNew_Password.dirty ||
                      refNew_Password.touched ||
                      refNew_Password.untouched)
                }" [(ngModel)]="PasswordModel.New_Password" class="form-control input-text-css" />
            </div>
            <div class="col-md-12 p-1">
              <span class="required-lable">Confirm Password</span>
              <input type="password" name="Confirm_Password " id="Confirm_Password " #refConfirm_Password="ngModel"
                required placeholder="Confirm Password" [ngClass]="{
                  'is-invalid': ddf.submitted && refConfirm_Password.invalid,
                  'alert-warning':
                    refConfirm_Password.invalid &&
                    (refConfirm_Password.dirty ||
                      refConfirm_Password.touched ||
                      refConfirm_Password.untouched)
                }" [(ngModel)]="PasswordModel.Confirm_Password" class="form-control input-text-css" />
            </div>
            <div class="col-md-12 p-1 mt-1">
              <div style="font-size: 0.75rem; color: #555; line-height: 1.5;">
                <div>* Minimum 8 characters.</div>
                <div>* Include at least 1 uppercase letter (A–Z) and 1 lowercase letter (a–z).</div>
                <div>* Include at least 1 number (0–9) and 1 special character (!@#$%^& etc.).</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" (click)="OnCloseChangePasswordModal()" class="btn btn-light font-size-12"
            data-dismiss="modal">
            Cancel
          </button>
          <button type="button" (click)="onUpdateChangePassword()" class="font-size-12 button-btn"
            [disabled]="!ddf.form.valid">
            Update
          </button>
        </div>
      </div>
    </div>
  </form>
</div>